export const GET_ADDRESS_FROM_POSTAL_CODE = 'GET_ADDRESS_FROM_POSTAL_CODE'
export const GET_ADDRESS_FROM_POSTAL_CODE_SUCCESS = 'GET_ADDRESS_FROM_POSTAL_CODE_SUCCESS'
export const GET_ADDRESS_FROM_POSTAL_CODE_FAILED = 'GET_ADDRESS_FROM_POSTAL_CODE_FAILED'
